module.exports = __webpack_public_path__ + "media/images/front/treatment_support/mv_appeal_refine-369d5ebe3ee964a27556faa4e193d90f.png";